import axios from "axios";
import { baseID, MSMEID, endpoints } from "../config/api";
import axiosErrorHandler from "./axiosHelpers";
import { Toast } from "./toast";
import { axiosInstance } from "./utilities";

export const addKnownSupplier = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.ADD_KNOWN_SUPPLIER,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const customerOnBoard = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_ONBOARD,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const cutomerContractCreate = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.Customer_Contract_Create,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const CustomerPurchaseOrderGet = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.Customer_Purchase_Order,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const DocumentAgreement = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.Document_Aggreement,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const storageList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.STORAGE_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const thirdPartyDocumentLIst = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.THIRD_PARTY_DOCUMENTS_List_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const PurchaseOrderApproval = async (params, body) => {
  const request = await axiosInstance
    .put(`${endpoints.customer.Proposal_order_Approved}${params}`, body)
    .catch(axiosErrorHandler);
  return request;
};

export const addressUpdate = async (body) => {
  const request = await axiosInstance
    .post(`${endpoints.customer.RESIDENTIAL_ADDRESS_UPDATE}`, body)
    .catch(axiosErrorHandler);
  return request;
};

export const PurchaseOrderCreate = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.Proposal_order_Create,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const SkipMarginPayment = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.SKIP_MARGIN_PAYMENT,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};


export const MSMERegistration = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.MSME_REGISTRATION,
      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const fileUpload = async (body) => {
  const request = await axiosInstance
    .post(endpoints.upload?.FILE_UPLOAD, body)
    .catch(axiosErrorHandler);
  return request;
};

export const customerSendOtp = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_SEND_OTP,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const customerSendOtpforCC = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_SEND_OTP,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const customerVerifyOtp = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_VERIFY_OTP,

      body,
    )
    .catch((e) => {
      return axiosErrorHandler(e, "signUp");
    });
  return request;
};

export const customerVerifyOtpRelease = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_VERIFY_OTP_RELEASE,
      body,
    )
    .catch(axiosErrorHandler);
  return request;
};

export const customerVerifyOtpCC = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_VERIFY_OTP,

      body
    )
    .catch((e) => {
      return axiosErrorHandler(e, "signUp");
    });
  return request;
};

export const panImageExtraction = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.PAN_IMAGE_EXTRACTION,

      body
    )
    .catch((e) => {
      // return axiosErrorHandler(e, "signUp");

    });
  return request;
};

export const deleteAccount = async () => {
  const request = await axiosInstance
    .delete(
      `${endpoints.common.DELETE_ACCOUNT}`
      // { params },
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getProfilePercentage = async (params) => {
  let header = {};
  const request = await axiosInstance
    .get(endpoints.common.PROFILE_PERCENTAGE, { header, params })
    .catch(axiosErrorHandler);
  return request;
};

export const updateProfile = async (body, id) => {
  const request = await axiosInstance
    .put(`${endpoints.common.UPDATE_PROFILE}?profileId=${id}`, body)
    .catch(axiosErrorHandler);
  return request;
};

export const getCustomerCare = async (params) => {
  const request = await axiosInstance
    .get(endpoints.customer.CUSTOMER_CARE_DETAILS, params)
    .catch(axiosErrorHandler);
  return request;
};

export const getProfile = async (params) => {
  const request = await axiosInstance
    .get(endpoints.common.GET_PROFILE, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const completeProfile = async (params) => {
  const request = await axiosInstance
    .get(endpoints.customer.REQUEST_TO_COMPLETE_PROFILE, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const getCityAndState = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.location.GET_CITY_STATE,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getPanNumberAdharNumberApi = async (params, NAME) => {
  const PanorAdharurl =
    NAME === "PANNUMBER"
      ? endpoints.customer.PROFILE_PAN_NUMBER
      : endpoints.customer.PROFILE_AADHAR_NUMBER;
  const request = await axiosInstance
    .post(
      PanorAdharurl,

      params
    )
    .catch((error) => {
      Toast({
        type: "error",
        message: error?.response?.data?.data?.status?.statusMessage,
      });
    });
  return request;
};

export const getAuthorizedPersonList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.AUTHORIZED_PERSON_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getCommodityList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.REQUIRED_COMMODITY_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getVarietyListApi = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.VARIETY_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const contractVerifyOTP = async (body, id) => {
  const request = await axiosInstance
    .put(
      `${endpoints.common.UPDATE_PROFILE}?id=${id}`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const uploadAddtionalDocument = async (body, id) => {
  const request = await axiosInstance
    .put(
      `${endpoints.customer?.UPLOAD_ADDTIONAL_DOCUMENT}?id=${id}`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const ReuploadAddtionalDocument = async (body, id, notifcationid) => {
  const request = await axiosInstance
    .put(
      `${endpoints.customer?.NOTIFICATION_REUPLOAD_DOCUMENT}?id=${id}&notificationId=${notifcationid} `,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getAllYourActivity = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.dashboard.YOUR_ACTIVITY_STATUS,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getYourActivityProgress = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.dashboard.YOUR_ACTIVITY_PROGRESS,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const customerIsExist = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_IS_EXIST,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};


export const authorizedPersonIsExist = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.AP_IS_EXIST,

      {params}
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getPurchaseOrderList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.purchase.GET_ALL_PURCHASE_ORDER_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getPurchaseOrderbyid = async (params) => {
  const request = await axiosInstance
    .get(`${endpoints.purchase.GET_BY_ID_PURCHASE_ORDER}?id=${params}`)
    .catch(axiosErrorHandler);
  return request;
};

export const createPurchaseRequest = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.purchase.CREATE_PURCHASE_REQUEST,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getViewQualityParameter = async (id) => {
  try {
    // let id = MSMEID;
    const request = await axiosInstance
      .get(`${endpoints.customer.VIEW_QUALITY_PARAMETER}`, {
        params: { id: id },
      })
      .catch(axiosErrorHandler);
    return request.data;
  } catch (error) {
    return axiosErrorHandler(error);
  }
};

export const addAddendumRequest = async (params, body) => {
  const request = await axiosInstance
    .put(
      `${endpoints.customer.ADDENDUM_UPDATE}?id=${params}`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const offlinepayment = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.purchase.OFFLINE_PAYMENT_REQUEST,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const offlinepaymentFirm = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.purchase.OFFLINE_PAYMENT_FIRM,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getAadhaarEntityName = async (id) => {
  const request = await axiosInstance
    .get(`${endpoints.customer.GET_AADHAR_ENTITY_NAME}`, { params: { id: id } })
    .catch(axiosErrorHandler);
  return request;
};

export const createRequestLocation = async (body) => {
  const request = await axiosInstance
    .post(endpoints.customer.CREATE_REQUEST_LOCATION, body)
    .catch(axiosErrorHandler);
  return request;
};

// export const getPublicIP = async () => {
//   try {
//     const response = await axios.get('https://api.ipify.org/');
//     const ip = await response.data;
//     console.log('Your public IP address is:', ip);
//     return ip;
//   } catch (error) {
//     console.error('Error fetching public IP:', error.message);
//     return null;
//   }
// }


export const getReleaseModuleList = async (params) => {
  const request = await axiosInstance.get(

    endpoints.customer.GET_RELEASE_REQUEST_DATA,

    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getReleaseList = async (params) => {
  const request = await axiosInstance.get(

    endpoints.customer.RELEASE_MODULE_LIST,

    { params },
  ).catch(axiosErrorHandler);
  return request;
};
export const getTransActionAll = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.ALLTRANSACTION_NEW_API,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getDeposit = async (params) => {
  const request = await axiosInstance.get(

    endpoints.finance.DEPOSIT_LIST,

    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getInvoiceListAll = async (params) => {
  const request = await axiosInstance.get(

    endpoints.finance.INVOICE_LIST,
    {
      params
    },
  ).catch(axiosErrorHandler);
  return request;
};

export const updateDeposit = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.finance.DEPOSIT_UPDATE}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateDepositNew = async (body, id) => {
  const request = await axiosInstance.put(
    `${endpoints.finance.DEPOSIT_UPDATE_NEW}?id=${id}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateInvoice = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.finance.INVOICE_UPDATE}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const getReleaseOrderList = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.GET_RELEASE_ORDER,
    { params },
  ).catch(axiosErrorHandler);
  return request;
}
export const updateReleaseOrder = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.customer.EDIT_RELEASE_REQUEST}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const getReleaseRequestList = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.RELEASE_MODULE_LIST,
    { params },
  ).catch(axiosErrorHandler);
  return request;
}

export const getReleaseOrderListData = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.RELEASE_ORDER_LIST,
    { params },
  ).catch(axiosErrorHandler);
  return request;
}

export const createCommodityRelease = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.COMMODITY_RELEASE,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const updateReleaseorder = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.customer.RELEASE_ORDER_UPDATE}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};
export const generateReleaseOrderApiNew = async (body) => {
  const request = await axiosInstance.post(

    `${endpoints.customer.RELEASE_ORDER_NEW}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};
export const generateReleaseOrderApi = async (body, id) => {
  const request = await axiosInstance.post(

    `${endpoints.customer.RELEASE_ORDER}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};



export const getReleaseOrderById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.GET_RELEASE_ORDER_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getReleaseRequestCompletedById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.GET_RELEASE_REQUEST_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};


export const getReleaseModuleById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.GET_RELEASE_MODULE_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getReleaseModuleContractById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.GET_CONTRACT_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};


export const createReleaseRequest = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CREATE_RELEASE_REQUEST,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};
export const updateReleaseRequest = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.customer.EDIT_RELEASE_REQUEST}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const getAuthorizedUserList = async (id) => {
  const request = await axiosInstance.get(
    `${endpoints.customer.AUTHORIZED_USER_LIST_NEW}?customerId=${id}`,
  ).catch(axiosErrorHandler);
  return request;
}
export const getAuthorizedUserList_New = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.AUTHORIZED_USER_LIST,
    { params },
  ).catch(axiosErrorHandler);
  return request;
}

export const getAgreementClauseList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.AGREEMENT_LIST_ITEM,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getReleasePdfList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.RELEASE_PDF_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getReleasePdfListByID = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.customer.RELEASE_PDF_LIST_BY_ID,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getReleaseCompletedViewDetails = async (id) => {
  const request = await axiosInstance
    .get(`${endpoints.customer.RELEASE_REQUEST_COMPLETED_VIEW_DETAILS}?id=${id}`,)
    .catch(axiosErrorHandler);
  return request;
};

export const createAgrementAmend = async (body, params) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CREATE_AGREEMENT_AMEND,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const acceptAgreement = async (params, body) => {

  const request = await axiosInstance
    .post(
      endpoints.customer.ACCEPT_AGREMENT,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;

};
export const getPaymentsAmount = async (body) => {

  const request = await axiosInstance
    .post(
      endpoints.customer.GET_PAYMENTS_DETAILS_AMOUNT,
      body)
    .catch(axiosErrorHandler);
  return request;

};

export const getThirdPartyUserList = async (params) => {
  const request = await axiosInstance.get(
    `${endpoints.customer.AUTHORIZED_USER_LIST}?userType=CUSTOMER&role=CUSTOMER&returnAll=true`
  ).catch(axiosErrorHandler);
  return request;
}

export const getThirdPartyUserListNew = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.CUSTOMER_PROFILE_COMPLETED_LIST_NEW,
    { params }
  ).catch(axiosErrorHandler);
  return request;
}


export const getReleaseRequestPdf = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.GET_RELEASE_REQUEST_PDF_DETAILS,
    { params }
  ).catch(axiosErrorHandler);
  return request;
}

export const getReleaseRate = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer.GET_RELEASE_RATE,
    { params }
  ).catch(axiosErrorHandler);
  return request;
}


export const userLogout = async (id) => {
  const request = await axiosInstance
    .put(`${endpoints.auth.LOGOUT}?id=${id}`,)
    .catch(axiosErrorHandler);
  return request;
};